import moment from "moment";
import {dateFromServer} from "services/helper";
import {validDate} from "components/form/validator/validations";

export const mutationTypes = {
    SET_DATE_OF_ISSUE_PROCEEDINGS: 'SET_DATE_OF_ISSUE_PROCEEDINGS',
    SET_DATE_OF_SERVICE_PROCEEDINGS: 'SET_DATE_OF_SERVICE_PROCEEDINGS',
    SET_DATE_OF_ASSUMED_SETTLEMENT: 'SET_DATE_OF_ASSUMED_SETTLEMENT',
    SET_AGE_OF_DEATH_TO_SETTLEMENT: 'SET_AGE_OF_DEATH_TO_SETTLEMENT',
    SET_AGE_AT_SETTLEMENT: 'SET_AGE_AT_SETTLEMENT',
    SET_PRE_LIT_OR_LIT: 'SET_PRE_LIT_OR_LIT',
    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER',
    RESET: 'RESET',
};

// Initial State
const state = {
    preLitOrLit: 'pre-lit',
    dateOfIssueProceedings: null,
    dateOfServiceProceedings: null,
    dateOfAssumedSettlement: null,
    periodDeathToSettlement: null,
    ageAtSettlement: null,
};

// Getters
const getters = {
    date: state => key => state[key],
    serviceOfProceedingsValid: (state, g, rs, rg) => {
        let mDateOfDeath = moment(rg['fatal/dependency/people/theDeceasedValue']('dateOfDeath'), 'DD/MM/YYYY');
        let mDateOfServiceOfProceedings = moment(rg['fatal/dependency/claimDetails/value']('serviceOfProceedings'), 'DD/MM/YYYY');
        let differenceInYears = moment(rg['fatal/dependency/claimDetails/value']('assumedSettlement'), 'DD/MM/YYYY').diff(mDateOfServiceOfProceedings, 'years');

        return differenceInYears <= 9 && differenceInYears >= 0
            && (
                (mDateOfDeath.isValid() ? mDateOfDeath.isBefore(mDateOfServiceOfProceedings) : true) ||
                (state.preLitOrLit !== 'litigated' ? true : mDateOfDeath.isBefore(mDateOfServiceOfProceedings))
            );
    },
    preTrialDependency: (state, g, rs, rg) => {
        const dateOfDeath = rg['fatal/dependency/people/theDeceasedValue']('dateOfDeath');
        return moment(state.dateOfAssumedSettlement, 'DD/MM/YYYY').diff(
            moment(dateOfDeath, 'DD/MM/YYYY'), 'years', true,
        );
    },
};

// Actions
const actions = {
    setIssueProceedings({commit}, date) {
        commit(mutationTypes.SET_DATE_OF_ISSUE_PROCEEDINGS, date);
    },
    setServiceProceedings({commit}, date) {
        commit(mutationTypes.SET_DATE_OF_SERVICE_PROCEEDINGS, date);
    },
    setAssumedSettlement({commit, dispatch}, date) {
        commit(mutationTypes.SET_DATE_OF_ASSUMED_SETTLEMENT, date);
        return Promise.all([
            dispatch('determineAgeOfDeathToSettlement'),
            dispatch('determineAgeAtSettlement'),
            dispatch('fatal/dependency/checkToUpdateMultipliers', null, {root: true}),
        ]);
    },
    setPreLitOrLit({commit}, value) {
        commit(mutationTypes.SET_PRE_LIT_OR_LIT, value);
    },
    determineAgeOfDeathToSettlement({commit, state, rootGetters}) {
        const mSettleDate = moment(state.dateOfAssumedSettlement, 'DD/MM/YYYY');
        const mDod = moment(rootGetters['fatal/dependency/people/theDeceasedValue']('dateOfDeath'), 'DD/MM/YYYY');
        if (mSettleDate.isValid() && mDod.isValid()) {
            commit(mutationTypes.SET_AGE_OF_DEATH_TO_SETTLEMENT, mSettleDate.diff(mDod, 'years', true));
        }
    },
    determineAgeAtSettlement({commit, state, rootGetters}) {
        const mSettleDate = moment(state.dateOfAssumedSettlement, 'DD/MM/YYYY');
        const mDob = moment(rootGetters['fatal/dependency/people/theDeceasedValue']('dateOfBirth'), 'DD/MM/YYYY');
        if (mSettleDate.isValid() && mDob.isValid()) {
            commit(mutationTypes.SET_AGE_AT_SETTLEMENT, mSettleDate.diff(mDob, 'years', true));
        }
    },
    /**
     * Loads the step being received from the Server, to be placed in the state.
     */
    load({ dispatch, action, commit }, step) {
        const data = _.deeply(_.mapKeys)(step, (value, key) => _.camelCase(key)).data;
        const proms = [];

        if (data.procedural_status) {
            proms.push(dispatch('setPreLitOrLit', dates.procedural_status));
        }
        if (dates.service_of_proceedings) {
            proms.push(dispatch('setServiceProceedings', dateFromServer(dates.service_of_proceedings)));
        }
        if (dates.assumed_settlement) {
            proms.push(dispatch('setAssumedSettlement', dateFromServer(dates.assumed_settlement)));
        }
        return Promise.all(proms).then(() => state.ageAtSettlement > 0);
    },

    reset({commit}) {
        commit(mutationTypes.RESET);
    },
};

// Mutations
const mutations = {
    [mutationTypes.SET_DATE_OF_ISSUE_PROCEEDINGS](state, payload) {
        state.dateOfIssueProceedings = payload;
    },
    [mutationTypes.SET_DATE_OF_SERVICE_PROCEEDINGS](state, payload) {
        state.dateOfServiceProceedings = payload;
    },
    [mutationTypes.SET_DATE_OF_ASSUMED_SETTLEMENT](state, payload) {
        state.dateOfAssumedSettlement = payload;
    },
    [mutationTypes.SET_AGE_OF_DEATH_TO_SETTLEMENT](state, payload) {
        state.periodDeathToSettlement = Math.round(payload * 10) / 10;
    },
    [mutationTypes.SET_AGE_AT_SETTLEMENT](state, payload) {
        state.ageAtSettlement = Math.round(payload * 10) / 10;
    },
    [mutationTypes.SET_PRE_LIT_OR_LIT](state, payload) {
        state.preLitOrLit = payload;
    },
    [mutationTypes.RESET](state) {
        state.preLitOrLit = 'pre-lit';
        state.dateOfIssueProceedings = null;
        state.dateOfServiceProceedings = null;
        state.dateOfAssumedSettlement = null;
        state.periodDeathToSettlement = null;
        state.ageAtSettlement = null;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/fatal/dependency/proceduralDates.js